var render = function render(){var _vm=this,_c=_vm._self._c;return _c('http-put-button',_vm._g(_vm._b({attrs:{"href":`/api/metadata/cloudaccounts/${(_vm.value || {}).id}/${_vm.type}`,"version":"v2","value":(_vm.value || {})[_vm.type || '']},on:{"http4xx":_vm.onError}},'http-put-button',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }